import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AttributesState } from './attributes.reducer';

export const selectAttributesState =
  createFeatureSelector<AttributesState>('attributes');

export const selectAttributes = createSelector(
  selectAttributesState,
  (state) => state.attributes,
);

export const selectAttributesMeta = createSelector(
  selectAttributesState,
  (state) => state.meta,
);

export const selectAttributesLoading = createSelector(
  selectAttributesState,
  (state) => state.isLoading,
);

export const selectAttributesSubmitting = createSelector(
  selectAttributesState,
  (state) => state.isSubmitting,
);

export const selectAttributesDeleting = createSelector(
  selectAttributesState,
  (state) => state.isDeleting,
);

export const selectAttributesExporting = createSelector(
  selectAttributesState,
  (state) => state.isExporting,
);

export const selectAttributesError = createSelector(
  selectAttributesState,
  (state) => state.error,
);

export const selectAttributesLastQuery = createSelector(
  selectAttributesState,
  (state) => state.lastQuery,
);

export const selectGs1AiDefinitions = createSelector(
  selectAttributesState,
  (state) => state.gs1AiDefinitions,
);

export const selectGs1DefinitionsLoading = createSelector(
  selectAttributesState,
  (state) => state.isGs1DefinitionsLoading,
);

export const selectAttributeOptions = createSelector(
  selectAttributesState,
  (state) => state.attributeOptions,
);

export const selectAttributeOptionsLoading = createSelector(
  selectAttributesState,
  (state) => state.isOptionsLoading,
);

export const selectAttributesLastExportJobId = createSelector(
  selectAttributesState,
  (state) => state.lastExportJobId,
);
